export const UNLOCK_CHOICE_DECISION_TIMEOUT_MS = 3000;
export const UNLOCK_CHOICE_LOADER_DELAY_MS = 300;
export const UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS = 1000;
// has to stay below the decision timeout, otherwise the whole choice modal falls back to the classic lead modal
export const UNLOCK_CHOICE_AVAILABILITY_WAIT_MS = 2000;
export const UNLOCK_CHOICE_DECISION_TIMEOUT_MS = 3000;
export const UNLOCK_CHOICE_LOADER_DELAY_MS = 300;
export const UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS = 1000;
// has to stay below the decision timeout, otherwise the whole choice modal falls back to the classic lead modal
export const UNLOCK_CHOICE_AVAILABILITY_WAIT_MS = 2000;
